import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M2.881 8.778a.75.75 0 0 1-.693-.46 2.24 2.24 0 0 1-.177-.866c0-1.53 1.59-2.819 4.05-3.285A.75.75 0 1 1 6.34 5.64c-1.84.348-2.829 1.193-2.829 1.812a.726.726 0 0 0 .061.287.749.749 0 0 1-.691 1.039Zm7.057-4.611a.75.75 0 1 0-.279 1.473c1.838.348 2.83 1.193 2.83 1.812 0 .831-1.549 1.744-3.719 1.925V2.685a.75.75 0 0 0-1.5 0v6.687a8.887 8.887 0 0 1-1.156-.165V7.934c0-.335-.2-.429-.442-.21l-1.7 1.537a.529.529 0 0 0 0 .8l1.7 1.537c.243.22.442.125.442-.21v-.655a11.627 11.627 0 0 0 1.156.14v2.443a.75.75 0 1 0 1.5 0v-2.43c3.023-.206 5.219-1.611 5.219-3.434 0-1.53-1.589-2.82-4.051-3.285Z';
const draw24px = 'M2.561,11.542a.75.75,0,0,1-.75-.75c0-2.543,3.06-4.666,7.615-5.283A.75.75,0,0,1,9.627,7c-3.66.495-6.316,2.092-6.316,3.8A.75.75,0,0,1,2.561,11.542ZM14.574,5.509A.75.75,0,0,0,14.373,7c3.66.495,6.316,2.091,6.316,3.8,0,1.806-3.324,3.8-8.154,3.944V3.02a.75.75,0,1,0-1.5,0V14.712a15.093,15.093,0,0,1-4.375-.834l1.908-1.251a.75.75,0,0,0-.823-1.254L4.38,13.579a.751.751,0,0,0-.216,1.039l2.207,3.364a.75.75,0,1,0,1.254-.822L6.461,15.385a16.846,16.846,0,0,0,4.574.827V21.02a.75.75,0,0,0,1.5,0V16.236c5.453-.145,9.654-2.48,9.654-5.444C22.189,8.249,19.129,6.126,14.574,5.509Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const OrbitIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'orbit'));
OrbitIcon.displayName = 'OrbitIcon';
OrbitIcon.propTypes = Icon.propTypes;
OrbitIcon.renderIcon = props => /*#__PURE__*/React.createElement(OrbitIcon, props);
export default OrbitIcon;
//# sourceMappingURL=OrbitIcon.js.map